import React, { Component } from 'react';
import './HorizontalFlex.css';

class HorizontalFlex extends Component {
    render() {
        var components = this.props.components;
        var predominant = this.props.predominant || -1;
        
        return <div className="HorizontalFlex">
        {
            components.map(function(component, index) {
                var style = {};

                if(index === parseInt(predominant)) style.flexGrow = 1;
                
                return <div className="HorizontalFlexChild" style={style}>{component}</div>;
            })
        }
        </div>;
    }
}

export default HorizontalFlex;
